var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 12,
    viewBox: "0 0 4 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.615356 6C0.615356 6.76338 1.23659 7.38462 1.99997 7.38462C2.76336 7.38462 3.38459 6.76338 3.38459 6C3.38459 5.23662 2.76336 4.61538 1.99997 4.61538C1.23659 4.61538 0.615356 5.23662 0.615356 6ZM0.615356 10.6154C0.615356 11.3788 1.23659 12 1.99997 12C2.76336 12 3.38459 11.3788 3.38459 10.6154C3.38459 9.852 2.76336 9.23077 1.99997 9.23077C1.23659 9.23077 0.615356 9.852 0.615356 10.6154ZM0.615356 1.38462C0.615356 2.148 1.23659 2.76923 1.99997 2.76923C2.76336 2.76923 3.38459 2.148 3.38459 1.38462C3.38459 0.621231 2.76336 0 1.99997 0C1.23659 0 0.615356 0.621231 0.615356 1.38462Z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.c22d2172f71aef96b260cc6d1baba39b.svg";
export { ForwardRef as ReactComponent };